import {
  ovl,
  type SYSAction,
  type SYSTableDefIds,
} from "../../../../_ovlclient/src"
import {
  _TableDetailViewScreenInstance_Type,
  TableGet,
  TableRefresh,
} from "../../../../_ovlclient/src/library/table/tableapi"
import { HookScreenNavigateIn_Type } from "../../../src/global/hooks"
import { HookScreenRefresh_Type } from "../../../src/library/screenapi"

const HookScreenRefresh: SYSAction<HookScreenRefresh_Type> = async (value) => {
  let detailViewState =
    ovl.getState().ovl.libState.tableDetailView.instances[value.instance]
  await _Refresh(detailViewState)
}

const HookScreenNavigateIn: SYSAction<HookScreenNavigateIn_Type> = async (
  value,
  { global }
) => {
  let detailViewState =
    ovl.getState().ovl.libState.tableDetailView.instances[value.instance]

  if (detailViewState.forceRefresh || !detailViewState.rowKey) {
    await _Refresh(detailViewState)
  }
}

const _Refresh = async (
  detailViewState: _TableDetailViewScreenInstance_Type
) => {
  let tb = TableGet(<SYSTableDefIds>detailViewState.defId)
  let idField = tb.def.database.dataIdField
  await tb.refresh({
    serverFilter: { [idField]: detailViewState.id },
    doNotRebuild: true,
  })
}

export let SYSTableDetailView = {
  hooks: { HookScreenNavigateIn, HookScreenRefresh },
}
